import React from "react";
import { useAppSelector } from "../../../app/hooks";
import Loading from "../../../components/Loading/Loading";
import { ExperienceCard } from "../../experience/types/types";
import { accountSelected } from "../../students/slice/studentSlice";
import { Student } from "../../students/types/types";
import {
  useGetAllExperienceStudentQuery,
  useUpdateExperienceStudentMutation,
} from "../api/experienceForStudentApi";
import ExpereinceForStudentPresentation from "../presentation/ExpereinceForStudentPresentation";
type ExperienceForStudentcontainerProps = {
  student: Student;
};
const ExperienceForStudentcontainer: React.FC<
ExperienceForStudentcontainerProps
> = ({ student }) => {
  const account = useAppSelector(accountSelected)
  const {
    data: expList,
    isLoading,
    isError,
    isSuccess
  } = useGetAllExperienceStudentQuery(
    {
      currentSystem: JSON.stringify(account),
      studentId: student?._id as string
    },
    {
      refetchOnMountOrArgChange: true
    }
  )

  const [
    updateExperience,
    {
      isLoading: updateLoading,

    },
  ] = useUpdateExperienceStudentMutation();

  const onChangeComplete = async (experience: ExperienceCard) => {
    try {
      await updateExperience({
        experience,
        student,
        complete: !experience.completion?.complete,
        currentSystem: account!
      }).unwrap()
    } catch (error) {
      console.error(error)
    }
  }

  let content
  if (updateLoading || isLoading) {
    content = <Loading />
  } else if (isSuccess) {
    content = (
      <ExpereinceForStudentPresentation
        explist={expList}
        onChangeComplete={onChangeComplete}
      />
    )
  }
  return <>{content}</>
}

export default ExperienceForStudentcontainer
